import axios from 'axios';

import URLS from '../../util/urls.js';
import widgets from "./util/widgets.js";
import GruposPermissoes from './util/gruposPermissoes.js';

const state = {
  usuarioPesquisa: {
    nome: undefined,
    perfil: undefined,
    pagina: 0
  },
  listaUsuarios: [],
  labelQuantidade: '',
  usuarioSelecionado: {
    id: 0,
    usuarioCorretor: true,
    comissao: 0,
    horariosDeAcesso: [],
    contasBancarias: [],
    permissoes: [
      { modulo: 'CLIENTES_ALUGUEL' },
      { modulo: 'IMOVEIS_ALUGUEL' },
      { modulo: 'CONTRATOS_ALUGUEL' },
      { modulo: 'RELATORIOS_CLIENTES_ALUGUEL' },
      { modulo: 'RELATORIOS_CONTRATOS_ALUGUEL' },
      { modulo: 'RELATORIOS_IMOVEIS_ALUGUEL' },
      { modulo: 'RELATORIOS_PRETENDENTES_ALUGUEL' },
      { modulo: 'RELATORIOS_FINANCEIROS_ALUGUEL' },
      { modulo: 'CLIENTES_VENDA' },
      { modulo: 'CONTRATOS_VENDA' },
      { modulo: 'IMOVEIS_VENDA' },
      { modulo: 'RELATORIOS_CAPTACOES_VENDA' },
      { modulo: 'RELATORIOS_COMISSOES_VENDA' },
      { modulo: 'RELATORIOS_CLIENTES_VENDA' },
      { modulo: 'RELATORIOS_IMOVEIS_VENDA' },
      { modulo: 'RELATORIOS_PRETENDENTES_VENDA' },
      { modulo: 'CONTAS_RECEBER' },
      { modulo: 'LANCAMENTOS_CONTAS_RECEBER' },
      { modulo: 'CONTAS_PAGAR' },
      { modulo: 'LANCAMENTOS_CONTAS_PAGAR' },
      { modulo: 'CAIXA' },
      { modulo: 'FORNECEDORES' },
      { modulo: 'PLANOS_CONTA' },
      { modulo: 'GRUPOS_CONTA' },
      { modulo: 'PRETENDENTES' },
      { modulo: 'ADMINISTRADORAS' },
      { modulo: 'CONDOMINIOS' },
      { modulo: 'PLACAS' },
      { modulo: 'USUARIOS' },
      { modulo: 'PERFIS_USUARIOS' },
      { modulo: 'CONTAS_BANCARIAS' },
      { modulo: 'PORTAIS' },
      { modulo: 'LOGS' },
      { modulo: 'VISITA' },
      { modulo: 'SISTEMA' }
    ],
    widgets: {
      inicioWidgets: 'GRAFICOS'
    }
  },

  grupoAluguelClientesCheckAll: false,
  grupoAluguelClientesChecklist: [],

  grupoAluguelBaixaCheckAll: false,
  grupoAluguelBaixaChecklist: [],

  grupoAluguelLiberacaoRepasseCheckAll: false,
  grupoAluguelLiberacaoRepasseChecklist: [],

  grupoAluguelImoveisCheckAll: false,
  grupoAluguelImoveisChecklist: [],

  grupoAluguelContratosCheckAll: false,
  grupoAluguelContratosChecklist: [],

  grupoAluguelReajusteCheckAll: false,
  grupoAluguelReajusteChecklist: [],

  grupoAluguelVencimentoCheckAll: false,
  grupoAluguelVencimentoChecklist: [],

  grupoRelatoriosClientesChecklist: [],

  grupoRelatoriosContratosCheckAll: false,
  grupoRelatoriosContratosChecklist: [],

  grupoRelatoriosImoveisCheckAll: false,
  grupoRelatoriosImoveisChecklist: [],

  grupoRelatoriosPretendentesChecklist: [],

  grupoRelatoriosFinanceirosCheckAll: false,
  grupoRelatoriosFinanceirosChecklist: [],

  grupoVendaClientesCheckAll: false,
  grupoVendaClientesChecklist: [],

  grupoVendaImoveisCheckAll: false,
  grupoVendaImoveisChecklist: [],

  grupoVendaContratosCheckAll: false,
  grupoVendaContratosChecklist: [],

  grupoVendaRelatoriosCheckAll: [],
  grupoVendaRelatoriosChecklist: [],

  grupoFinanceiroContasReceberCheckAll: false,
  grupoFinanceiroContasReceberChecklist: [],

  grupoFinanceiroLancamentosReceberCheckAll: false,
  grupoFinanceiroLancamentosReceberChecklist: [],

  grupoFinanceiroContasPagarCheckAll: false,
  grupoFinanceiroContasPagarChecklist: [],

  grupoFinanceiroLancamentosPagarCheckAll: false,
  grupoFinanceiroLancamentosPagarChecklist: [],

  grupoFinanceiroCaixaCheckAll: false,
  grupoFinanceiroCaixaChecklist: [],

  grupoFinanceiroFornecedoresCheckAll: false,
  grupoFinanceiroFornecedoresChecklist: [],

  grupoFinanceiroPlanosContaCheckAll: false,
  grupoFinanceiroPlanosContaChecklist: [],

  grupoFinanceiroGruposContaCheckAll: false,
  grupoFinanceiroGruposContaChecklist: [],

  grupoFinanceiroRelatoriosCheckAll: false,
  grupoFinanceiroRelatoriosChecklist: [],

  grupoConfiguracoesPretendentesCheckAll: false,
  grupoConfiguracoesPretendentesChecklist: [],

  grupoConfiguracoesCondominiosCheckAll: false,
  grupoConfiguracoesCondominiosChecklist: [],

  grupoConfiguracoesAdministradorasCheckAll: false,
  grupoConfiguracoesAdministradorasChecklist: [],

  grupoConfiguracoesUsuariosCheckAll: false,
  grupoConfiguracoesUsuariosChecklist: [],

  grupoConfiguracoesPerfisCheckAll: false,
  grupoConfiguracoesPerfisChecklist: [],

  grupoConfiguracoesPlacasCheckAll: false,
  grupoConfiguracoesPlacasChecklist: [],

  grupoConfiguracoesContasCheckAll: false,
  grupoConfiguracoesContasChecklist: [],

  grupoConfiguracoesPortaisCheckAll: false,
  grupoConfiguracoesPortaisChecklist: [],

  grupoConfiguracoesLogsCheckAll: false,
  grupoConfiguracoesLogsChecklist: [],

  grupoConfiguracoesVisitasCheckAll: false,
  grupoConfiguracoesVisitasChecklist: [],

  grupoConfiguracoesSistemaCheckAll: false,
  grupoConfiguracoesSistemaChecklist: [],

  perfisSelect: [],
  perfilSelecionado: undefined
}

const mutations = {
  limparUsuarioPesquisa(state) {
    state.usuarioPesquisa.nome = undefined;
    state.usuarioPesquisa.pagina = 0;
  },
  atualizarListaUsuarios(state, payload) {
    if(state.usuarioPesquisa.pagina === 0) {
      state.listaUsuarios = payload.lista;
    } else {
      state.listaUsuarios.push(...payload.lista);
    }
    switch(payload.quantidade) {
      case 0:
        state.labelQuantidade = "Nenhum Usuário encontrado";
        break;
      case 1:
        state.labelQuantidade = "1 Usuário encontrado";
        break;
      default:
        state.labelQuantidade = `${payload.quantidade} Usuários encontrados`;
    }
  },
  limparUsuariosListados(state) {
    state.listaUsuarios = [];
  },
  atualizarUsuarioSelecionado(state, payload) {
    state.usuarioSelecionado = payload;

    if(state.usuarioSelecionado.widgets === null) { state.usuarioSelecionado.widgets = {}; }
  },
  atualizarPermissoesUsuarioSelecionado(state, objeto) {
    let clientesAluguel = objeto.permissoes
      .filter((permissao) => {
        return permissao.modulo === "CLIENTES_ALUGUEL";
      })[0];
    
    state.grupoAluguelClientesCheckAll = false;
    state.grupoAluguelClientesChecklist = [];
    state.grupoAluguelBaixaCheckAll = false;
    state.grupoAluguelBaixaChecklist = [];
    state.grupoAluguelLiberacaoRepasseCheckAll = false;
    state.grupoAluguelLiberacaoRepasseChecklist = [];

    if(clientesAluguel) {
      // Preenchendo as checkboxes do grupo Aluguel -> Clientes
      for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_CLIENTES) {
        if(clientesAluguel[permissao]) {
          state.grupoAluguelClientesChecklist.push(permissao);
        }
      }
      // Preenchendo as checkboxes do grupo Aluguel -> Baixa do aluguel
      for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_BAIXA) {
        if(clientesAluguel[permissao]) {
          state.grupoAluguelBaixaChecklist.push(permissao);
        }
      }
      // Preenchendo as checkboxes do grupo Aluguel -> Liberação do repasse
      for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_LIBERACAO_REPASSE) {
        if(clientesAluguel[permissao]) {
          state.grupoAluguelLiberacaoRepasseChecklist.push(permissao);
        }
      }
    }
    
    let imoveisAluguel = objeto.permissoes
      .filter((permissao) => {
        return permissao.modulo === "IMOVEIS_ALUGUEL";
      })[0];

    // Preenchendo as checkboxes do grupo Aluguel -> Imóveis
    state.grupoAluguelImoveisCheckAll = false;
    state.grupoAluguelImoveisChecklist = [];

    if(imoveisAluguel) {
      for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_IMOVEIS) {
        if(imoveisAluguel[permissao]) {
          state.grupoAluguelImoveisChecklist.push(permissao);
        }
      }
    }

    let contratosAluguel = objeto.permissoes
      .filter((permissao) => {
        return permissao.modulo === 'CONTRATOS_ALUGUEL'
      })[0];

    state.grupoAluguelContratosCheckAll = false;
    state.grupoAluguelContratosChecklist = [];
    state.grupoAluguelReajusteCheckAll = false;
    state.grupoAluguelReajusteChecklist = [];
    state.grupoAluguelVencimentoCheckAll = false;
    state.grupoAluguelVencimentoChecklist = [];

    if(contratosAluguel) {
      // Preenchendo as checkboxes do grupo Aluguel -> Contratos
      for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_CONTRATOS) {
        if(contratosAluguel[permissao]) {
          state.grupoAluguelContratosChecklist.push(permissao);
        }
      }

      // Preenchendo as checkboxes do grupo Aluguel -> Reajuste/Renovação/Prorrogação
      for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_REAJUSTE) {
        if(contratosAluguel[permissao]) {
          state.grupoAluguelReajusteChecklist.push(permissao);
        }
      }

      // Preenchendo as checkboxes do grupo Aluguel -> Vencimento/Carência/Tx. Adm
      for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_VENCIMENTO) {
        if(contratosAluguel[permissao]) {
          state.grupoAluguelVencimentoChecklist.push(permissao);
        }
      }
    }

    let relatoriosClientesAluguel = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_CLIENTES_ALUGUEL'
      })[0];

    // Preenchendo a checkbox Relatórios de Aluguel -> Relatórios de Clientes
    state.grupoRelatoriosClientesChecklist = [];

    if(relatoriosClientesAluguel) {
      if(relatoriosClientesAluguel['visualizacao']) {
        state.grupoRelatoriosClientesChecklist.push('visualizacao');
      }
    }

    let relatoriosContratosAluguel = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_CONTRATOS_ALUGUEL'
      })[0];

    // Preenchendo as checkboxes do grupo Relatórios de Aluguel -> Relatórios de Contratos
    state.grupoRelatoriosContratosCheckAll = false;
    state.grupoRelatoriosContratosChecklist = [];

    if(relatoriosContratosAluguel) {
      for(let permissao of GruposPermissoes.PERMISSOES_RELATORIOS_CONTRATOS) {
        if(relatoriosContratosAluguel[permissao]) {
          state.grupoRelatoriosContratosChecklist.push(permissao);
        }
      }
    }

    let relatoriosImoveisAluguel = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_IMOVEIS_ALUGUEL'
      })[0];

    // Preenchendo as checkboxes do grupo Relatórios de Aluguel -> Relatórios de Imóveis
    state.grupoRelatoriosImoveisCheckAll = false;
    state.grupoRelatoriosImoveisChecklist = [];

    if(relatoriosImoveisAluguel) {
      for(let permissao of GruposPermissoes.PERMISSOES_RELATORIOS_IMOVEIS) {
        if(relatoriosImoveisAluguel[permissao]) {
          state.grupoRelatoriosImoveisChecklist.push(permissao);
        }
      }
    }

    let relatoriosPretendentesAluguel = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_PRETENDENTES_ALUGUEL'
      })[0];

    // Preenchendo a checkbox do grupo Relatórios de Aluguel -> Relatórios de Pretendentes
    state.grupoRelatoriosPretendentesChecklist = [];

    if(relatoriosPretendentesAluguel) {
      if(relatoriosPretendentesAluguel['visualizacao']) {
        state.grupoRelatoriosPretendentesChecklist.push('visualizacao');
      }
    }

    let relatoriosFinanceirosAluguel = objeto.permissoes
      .filter((permissao) => {
        return permissao.modulo === 'RELATORIOS_FINANCEIROS_ALUGUEL'
      })[0];

    // Preenchendo as checkboxes do grupo Relatórios de Aluguel -> Relatórios Financeiros
    state.grupoRelatoriosFinanceirosCheckAll = false;
    state.grupoRelatoriosFinanceirosChecklist = [];

    if(relatoriosFinanceirosAluguel) {
      for(let permissao of GruposPermissoes.PERMISSOES_RELATORIOS_FINANCEIROS) {
        if(relatoriosFinanceirosAluguel[permissao]) {
          state.grupoRelatoriosFinanceirosChecklist.push(permissao);
        }
      }
    }

    let clientesVenda = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'CLIENTES_VENDA'
      })[0];

    // Preenchendo as checkboxes do grupo Venda -> Clientes
    state.grupoVendaClientesCheckAll = false;
    state.grupoVendaClientesChecklist = [];

    if(clientesVenda) {
      for(let permissao of GruposPermissoes.PERMISSOES_VENDA_CLIENTES) {
        if(clientesVenda[permissao]) {
          state.grupoVendaClientesChecklist.push(permissao);
        }
      }
    }

    let imoveisVenda = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'IMOVEIS_VENDA'
      })[0];

    // Preenchendo as checkboxes do grupo Venda -> Imóveis
    state.grupoVendaImoveisCheckAll = false;
    state.grupoVendaImoveisChecklist = [];

    if(imoveisVenda) {
      for(let permissao of GruposPermissoes.PERMISSOES_VENDA_IMOVEIS) {
        if(imoveisVenda[permissao]) {
          state.grupoVendaImoveisChecklist.push(permissao);
        }
      }
    }

    let contratosVenda = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'CONTRATOS_VENDA'
      })[0];

    // Preenchendo as checkboxes do grupo Venda -> Contratos
    state.grupoVendaContratosCheckAll = false;
    state.grupoVendaContratosChecklist = [];

    if(contratosVenda) {
      for(let permissao of GruposPermissoes.PERMISSOES_VENDA_CONTRATOS) {
        if(contratosVenda[permissao]) {
          state.grupoVendaContratosChecklist.push(permissao);
        }
      }
    }

    let relatoriosCaptacoesVenda = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_CAPTACOES_VENDA'
      })[0];
    
    let relatoriosComissoesVenda = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_COMISSOES_VENDA'
      })[0];

    let relatoriosClientesVenda = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_CLIENTES_VENDA'
      })[0];

    let relatoriosImoveisVenda = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_IMOVEIS_VENDA'
      })[0];

    let relatoriosPretendentesVenda = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_PRETENDENTES_VENDA'
      })[0];

    // Preenchendo as checkboxes do grupo Venda -> Relatórios
    state.grupoVendaRelatoriosCheckAll = false;
    state.grupoVendaRelatoriosChecklist = [];

    if(relatoriosCaptacoesVenda) {
      if(relatoriosCaptacoesVenda['visualizacao']) {
        state.grupoVendaRelatoriosChecklist.push('captacoesVisualizacao');
      }
    }

    if(relatoriosComissoesVenda) {
      if(relatoriosComissoesVenda['visualizacao']) {
        state.grupoVendaRelatoriosChecklist.push('comissoesVisualizacao');
      }
      if(relatoriosComissoesVenda['visualizacaoSomenteComissoesCorretor']) {
        state.grupoVendaRelatoriosChecklist.push('visualizacaoSomenteComissoesCorretor');
      }
    }

    if(relatoriosClientesVenda) {
      if(relatoriosClientesVenda['visualizacao']) {
        state.grupoVendaRelatoriosChecklist.push('clientesVisualizacao');
      }
    }

    if(relatoriosImoveisVenda) {
      if(relatoriosImoveisVenda['visualizacao']) {
        state.grupoVendaRelatoriosChecklist.push('imoveisVisualizacao');
      }
    }

    if(relatoriosPretendentesVenda) {
      if(relatoriosPretendentesVenda['visualizacao']) {
        state.grupoVendaRelatoriosChecklist.push('pretendentesVisualizacao');
      }
    }

    let contasReceber = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'CONTAS_RECEBER'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Contas a Receber
    state.grupoFinanceiroContasReceberCheckAll = false;
    state.grupoFinanceiroContasReceberChecklist = [];

    if(contasReceber) {
      for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_CONTAS_RECEBER) {
        if(contasReceber[permissao]) {
          state.grupoFinanceiroContasReceberChecklist.push(permissao);
        }
      }
    }

    let lancamentosContasReceber = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'LANCAMENTOS_CONTAS_RECEBER'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Lançamentos - Contas a Receber
    state.grupoFinanceiroLancamentosReceberCheckAll = false;
    state.grupoFinanceiroLancamentosReceberChecklist = [];

    if(lancamentosContasReceber) {
      for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_LANCAMENTOS_RECEBER) {
        if(lancamentosContasReceber[permissao]) {
          state.grupoFinanceiroLancamentosReceberChecklist.push(permissao);
        }
      }
    }

    let contasPagar = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'CONTAS_PAGAR'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Contas a Pagar
    state.grupoFinanceiroContasPagarCheckAll = false;
    state.grupoFinanceiroContasPagarChecklist = [];

    if(contasPagar) {
      for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_CONTAS_PAGAR) {
        if(contasPagar[permissao]) {
          state.grupoFinanceiroContasPagarChecklist.push(permissao);
        }
      }
    }

    let lancamentosContasPagar = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'LANCAMENTOS_CONTAS_PAGAR'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Lançamentos - Contas a Pagar
    state.grupoFinanceiroLancamentosPagarCheckAll = false;
    state.grupoFinanceiroLancamentosPagarChecklist = [];

    if(lancamentosContasPagar) {
      for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_LANCAMENTOS_PAGAR) {
        if(lancamentosContasPagar[permissao]) {
          state.grupoFinanceiroLancamentosPagarChecklist.push(permissao);
        }
      }
    }

    let caixa = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'CAIXA'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Caixa
    state.grupoFinanceiroCaixaCheckAll = false;
    state.grupoFinanceiroCaixaChecklist = [];
    
    if(caixa) {
      for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_CAIXA) {
        if(caixa[permissao]) {
          state.grupoFinanceiroCaixaChecklist.push(permissao);
        }
      }
    }

    let fornecedores = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'FORNECEDORES'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Fornecedores
    state.grupoFinanceiroFornecedoresCheckAll = false;
    state.grupoFinanceiroFornecedoresChecklist = [];

    if(fornecedores) {
      for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_FORNECEDORES) {
        if(fornecedores[permissao]) {
          state.grupoFinanceiroFornecedoresChecklist.push(permissao);
        }
      }
    }

    let planosConta = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'PLANOS_CONTA'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Planos de Conta
    state.grupoFinanceiroPlanosContaCheckAll = false;
    state.grupoFinanceiroPlanosContaChecklist = [];

    if(planosConta) {
      for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_PLANOS_CONTA) {
        if(planosConta[permissao]) {
          state.grupoFinanceiroPlanosContaChecklist.push(permissao);
        }
      }
    }

    let gruposConta = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'GRUPOS_CONTA'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Grupos de Conta
    state.grupoFinanceiroGruposContaCheckAll = false;
    state.grupoFinanceiroGruposContaChecklist = [];

    if(gruposConta) {
      for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_GRUPOS_CONTA) {
        if(gruposConta[permissao]) {
          state.grupoFinanceiroGruposContaChecklist.push(permissao);
        }
      }
    }

    // Preenchendo as checkboxes do grupo Financeiro -> Relatórios
    if(contasPagar) {
      if(contasPagar['relatorioContasPagas']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioContasPagas');
      }
    }

    if(contasPagar) {
      if(contasPagar['relatorioContasAPagar']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioContasAPagar');
      }
    }

    if(contasPagar) {
      if(contasPagar['relatorioContasAPagarVencidas']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioContasAPagarVencidas');
      }
    }

    if(contasReceber) {
      if(contasReceber['relatorioContasRecebidas']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioContasRecebidas');
      }
    }

    if(contasReceber) {
      if(contasReceber['relatorioContasAReceber']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioContasAReceber');
      }
    }

    if(contasReceber) {
      if(contasReceber['relatorioContasAReceberVencidas']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioContasAReceberVencidas');
      }
    }
    
    if(contasReceber) {
      if(contasReceber['relatorioCheques']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioCheques');
      }
    }

    if(contasReceber) {
      if(contasReceber['relatorioRemessasGeradasFinanceiro']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioRemessasGeradasFinanceiro');
      }
    }
   
    let pretendentes = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'PRETENDENTES'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Pretendentes
    state.grupoConfiguracoesPretendentesCheckAll = false;
    state.grupoConfiguracoesPretendentesChecklist = [];

    if(pretendentes) {
      for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_PRETENDENTES) {
        if(pretendentes[permissao]) {
          state.grupoConfiguracoesPretendentesChecklist.push(permissao);
        }
      }
    }

    let condominios = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'CONDOMINIOS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Condomínios
    state.grupoConfiguracoesCondominiosCheckAll = false;
    state.grupoConfiguracoesCondominiosChecklist = [];

    if(condominios) {
      for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_CONDOMINIOS) {
        if(condominios[permissao]) {
          state.grupoConfiguracoesCondominiosChecklist.push(permissao);
        }
      }
    }

    let administradoras = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'ADMINISTRADORAS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Administradoras
    state.grupoConfiguracoesAdministradorasCheckAll = false;
    state.grupoConfiguracoesAdministradorasChecklist = [];

    if(administradoras) {
      for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_ADMINISTRADORAS) {
        if(administradoras[permissao]) {
          state.grupoConfiguracoesAdministradorasChecklist.push(permissao);
        }
      }
    }

    let usuarios = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'USUARIOS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Usuários
    state.grupoConfiguracoesUsuariosCheckAll = false;
    state.grupoConfiguracoesUsuariosChecklist = [];

    if(usuarios) {
      for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_USUARIOS) {
        if(usuarios[permissao]) {
          state.grupoConfiguracoesUsuariosChecklist.push(permissao);
        }
      }
    }

    let perfisUsuarios = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'PERFIS_USUARIOS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Perfis
    state.grupoConfiguracoesPerfisCheckAll = false;
    state.grupoConfiguracoesPerfisChecklist = [];

    if(perfisUsuarios) {
      for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_PERFIS) {
        if(perfisUsuarios[permissao]) {
          state.grupoConfiguracoesPerfisChecklist.push(permissao);
        }
      }
    }

    let placas = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'PLACAS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Placas
    state.grupoConfiguracoesPlacasCheckAll = false;
    state.grupoConfiguracoesPlacasChecklist = [];

    if(placas) {
      for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_PLACAS) {
        if(placas[permissao]) {
          state.grupoConfiguracoesPlacasChecklist.push(permissao);
        }
      }
    }

    let contasBancarias = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'CONTAS_BANCARIAS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Contas Bancárias
    state.grupoConfiguracoesContasCheckAll = false;
    state.grupoConfiguracoesContasChecklist = [];

    if(contasBancarias) {
      for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_CONTAS) {
        if(contasBancarias[permissao]) {
          state.grupoConfiguracoesContasChecklist.push(permissao);
        }
      }
    }

    let portais = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'PORTAIS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Portais/Site
    state.grupoConfiguracoesPortaisCheckAll = false;
    state.grupoConfiguracoesPortaisChecklist = [];

    if(portais) {
      for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_PORTAIS) {
        if(portais[permissao]) {
          state.grupoConfiguracoesPortaisChecklist.push(permissao);
        }
      }
    }

    let logs = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'LOGS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Logs de Acesso
    state.grupoConfiguracoesLogsCheckAll = false;
    state.grupoConfiguracoesLogsChecklist = [];

    if(logs) {
      for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_LOGS) {
        if(logs[permissao]) {
          state.grupoConfiguracoesLogsChecklist.push(permissao);
        }
      }
    }

    let visita = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'VISITA'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Visitas
    state.grupoConfiguracoesVisitasCheckAll = false;
    state.grupoConfiguracoesVisitasChecklist = [];

    if(visita) {
      for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_VISITAS) {
        if(visita[permissao]) {
          state.grupoConfiguracoesVisitasChecklist.push(permissao);
        }
      }
    }

    let sistema = objeto.permissoes
      .filter((item) => {
        return item.modulo === 'SISTEMA'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Sistema
    state.grupoConfiguracoesSistemaCheckAll = false;
    state.grupoConfiguracoesSistemaChecklist = [];

    if(sistema) {
      for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_SISTEMA) {
        if(sistema[permissao]) {
          state.grupoConfiguracoesSistemaChecklist.push(permissao);
        }
      }
    }
  },
  atualizarWidgetsUsuarioSelecionado(state, objeto) {
    state.usuarioSelecionado.widgets = objeto.widgets;
  },
  limparUsuarioSelecionado(state) {
    state.usuarioSelecionado = {
      id: 0,
      usuarioCorretor: true,
      comissao: 0,
      horariosDeAcesso: [],
      contasBancarias: [],
      permissoes: [
        { modulo: 'CLIENTES_ALUGUEL' },
        { modulo: 'IMOVEIS_ALUGUEL' },
        { modulo: 'CONTRATOS_ALUGUEL' },
        { modulo: 'RELATORIOS_CLIENTES_ALUGUEL' },
        { modulo: 'RELATORIOS_CONTRATOS_ALUGUEL' },
        { modulo: 'RELATORIOS_IMOVEIS_ALUGUEL' },
        { modulo: 'RELATORIOS_PRETENDENTES_ALUGUEL' },
        { modulo: 'RELATORIOS_FINANCEIROS_ALUGUEL' },
        { modulo: 'CLIENTES_VENDA' },
        { modulo: 'CONTRATOS_VENDA' },
        { modulo: 'IMOVEIS_VENDA' },
        { modulo: 'RELATORIOS_CAPTACOES_VENDA' },
        { modulo: 'RELATORIOS_COMISSOES_VENDA' },
        { modulo: 'RELATORIOS_CLIENTES_VENDA' },
        { modulo: 'RELATORIOS_IMOVEIS_VENDA' },
        { modulo: 'RELATORIOS_PRETENDENTES_VENDA' },
        { modulo: 'CONTAS_RECEBER' },
        { modulo: 'LANCAMENTOS_CONTAS_RECEBER' },
        { modulo: 'CONTAS_PAGAR' },
        { modulo: 'LANCAMENTOS_CONTAS_PAGAR' },
        { modulo: 'CAIXA' },
        { modulo: 'FORNECEDORES' },
        { modulo: 'PLANOS_CONTA' },
        { modulo: 'GRUPOS_CONTA' },
        { modulo: 'PRETENDENTES' },
        { modulo: 'ADMINISTRADORAS' },
        { modulo: 'CONDOMINIOS' },
        { modulo: 'PLACAS' },
        { modulo: 'USUARIOS' },
        { modulo: 'PERFIS_USUARIOS' },
        { modulo: 'CONTAS_BANCARIAS' },
        { modulo: 'PORTAIS' },
        { modulo: 'LOGS' },
        { modulo: 'VISITA' },
        { modulo: 'SISTEMA' }
      ],
      widgets: Object.assign({}, widgets)
    };
  },
  limparPermissoesEWidgetsUsuarioSelecionado(state) {
    state.grupoAluguelClientesCheckAll = false;
    state.grupoAluguelClientesChecklist = [];

    state.grupoAluguelBaixaCheckAll = false;
    state.grupoAluguelBaixaChecklist = [];

    state.grupoAluguelLiberacaoRepasseCheckAll = false;
    state.grupoAluguelLiberacaoRepasseChecklist = [];

    state.grupoAluguelImoveisCheckAll = false;
    state.grupoAluguelImoveisChecklist = [];

    state.grupoAluguelContratosCheckAll = false;
    state.grupoAluguelContratosChecklist = [];

    state.grupoAluguelReajusteCheckAll = false;
    state.grupoAluguelReajusteChecklist = [];

    state.grupoAluguelVencimentoCheckAll = false;
    state.grupoAluguelVencimentoChecklist = [];

    state.grupoRelatoriosClientesChecklist = [];

    state.grupoRelatoriosContratosCheckAll = false;
    state.grupoRelatoriosContratosChecklist = [];

    state.grupoRelatoriosImoveisCheckAll = false;
    state.grupoRelatoriosImoveisChecklist = [];

    state.grupoRelatoriosPretendentesChecklist = [];

    state.grupoRelatoriosFinanceirosCheckAll = false;
    state.grupoRelatoriosFinanceirosChecklist = [];

    state.grupoVendaClientesCheckAll = false;
    state.grupoVendaClientesChecklist = [];

    state.grupoVendaImoveisCheckAll = false;
    state.grupoVendaImoveisChecklist = [];

    state.grupoVendaContratosCheckAll = false;
    state.grupoVendaContratosChecklist = [];

    state.grupoVendaRelatoriosCheckAll = false;
    state.grupoVendaRelatoriosChecklist = [];

    state.grupoFinanceiroContasReceberCheckAll = false;
    state.grupoFinanceiroContasReceberChecklist = [];

    state.grupoFinanceiroLancamentosReceberCheckAll = false;
    state.grupoFinanceiroLancamentosReceberChecklist = [];

    state.grupoFinanceiroContasPagarCheckAll = false;
    state.grupoFinanceiroContasPagarChecklist = [];

    state.grupoFinanceiroLancamentosPagarCheckAll = false;
    state.grupoFinanceiroLancamentosPagarChecklist = [];

    state.grupoFinanceiroCaixaCheckAll = false;
    state.grupoFinanceiroCaixaChecklist = [];

    state.grupoFinanceiroFornecedoresCheckAll = false;
    state.grupoFinanceiroFornecedoresChecklist = [];

    state.grupoFinanceiroPlanosContaCheckAll = false;
    state.grupoFinanceiroPlanosContaChecklist = [];

    state.grupoFinanceiroGruposContaCheckAll = false;
    state.grupoFinanceiroGruposContaChecklist = [];

    state.grupoFinanceiroRelatoriosCheckAll = false;
    state.grupoFinanceiroRelatoriosChecklist = [];

    state.grupoConfiguracoesPretendentesCheckAll = false;
    state.grupoConfiguracoesPretendentesChecklist = [];

    state.grupoConfiguracoesCondominiosCheckAll = false;
    state.grupoConfiguracoesCondominiosChecklist = [];

    state.grupoConfiguracoesAdministradorasCheckAll = false;
    state.grupoConfiguracoesAdministradorasChecklist = [];

    state.grupoConfiguracoesUsuariosCheckAll = false;
    state.grupoConfiguracoesUsuariosChecklist = [];

    state.grupoConfiguracoesPerfisCheckAll = false;
    state.grupoConfiguracoesPerfisChecklist = [];

    state.grupoConfiguracoesPlacasCheckAll = false;
    state.grupoConfiguracoesPlacasChecklist = [];

    state.grupoConfiguracoesContasCheckAll = false;
    state.grupoConfiguracoesContasChecklist = [];

    state.grupoConfiguracoesPortaisCheckAll = false;
    state.grupoConfiguracoesPortaisChecklist = [];

    state.grupoConfiguracoesLogsCheckAll = false;
    state.grupoConfiguracoesLogsChecklist = [];

    state.grupoConfiguracoesVisitasCheckAll = false;
    state.grupoConfiguracoesVisitasChecklist = [];

    state.grupoConfiguracoesSistemaCheckAll = false;
    state.grupoConfiguracoesSistemaChecklist = [];

    state.usuarioSelecionado.widgets = {};
  },
  atualizarListaContas(state, payload) {
    state.usuarioSelecionado.contasBancarias = payload;
  },
  atualizarPerfisSelect(state, payload) {
    state.perfisSelect = payload;
  },
  setPerfilSelecionado(state, payload) {
    state.perfilSelecionado = payload;
  },

  setGrupoAluguelClientesCheckAll(state, value) {
    state.grupoAluguelClientesCheckAll = value;
  },
  setGrupoAluguelClientesChecklist(state, value) {
    state.grupoAluguelClientesChecklist = value;
  },

  setGrupoAluguelBaixaCheckAll(state, value) {
    state.grupoAluguelBaixaCheckAll = value;
  },
  setGrupoAluguelBaixaChecklist(state, value) {
    state.grupoAluguelBaixaChecklist = value;
  },

  setGrupoAluguelLiberacaoRepasseCheckAll(state, value) {
    state.grupoAluguelLiberacaoRepasseCheckAll = value;
  },
  setGrupoAluguelLiberacaoRepasseChecklist(state, value) {
    state.grupoAluguelLiberacaoRepasseChecklist = value;
  },

  setGrupoAluguelImoveisCheckAll(state, value) {
    state.grupoAluguelImoveisCheckAll = value;
  },
  setGrupoAluguelImoveisChecklist(state, value) {
    state.grupoAluguelImoveisChecklist = value;
  },

  setGrupoAluguelContratosCheckAll(state, value) {
    state.grupoAluguelContratosCheckAll = value;
  },
  setGrupoAluguelContratosChecklist(state, value) {
    state.grupoAluguelContratosChecklist = value;
  },

  setGrupoAluguelReajusteCheckAll(state, value) {
    state.grupoAluguelReajusteCheckAll = value;
  },
  setGrupoAluguelReajusteChecklist(state, value) {
    state.grupoAluguelReajusteChecklist = value;
  },

  setGrupoAluguelVencimentoCheckAll(state, value) {
    state.grupoAluguelVencimentoCheckAll = value;
  },
  setGrupoAluguelVencimentoChecklist(state, value) {
    state.grupoAluguelVencimentoChecklist = value;
  },

  setGrupoRelatoriosClientesChecklist(state, value) {
    state.grupoRelatoriosClientesChecklist = value;
  },

  setGrupoRelatoriosContratosCheckAll(state, value) {
    state.grupoRelatoriosContratosCheckAll = value;
  },
  setGrupoRelatoriosContratosChecklist(state, value) {
    state.grupoRelatoriosContratosChecklist = value;
  },

  setGrupoRelatoriosImoveisCheckAll(state, value) {
    state.grupoRelatoriosImoveisCheckAll = value;
  },
  setGrupoRelatoriosImoveisChecklist(state, value) {
    state.grupoRelatoriosImoveisChecklist = value;
  },

  setGrupoRelatoriosPretendentesChecklist(state, value) {
    state.grupoRelatoriosPretendentesChecklist = value;
  },

  setGrupoRelatoriosFinanceirosCheckAll(state, value) {
    state.grupoRelatoriosFinanceirosCheckAll = value;
  },
  setGrupoRelatoriosFinanceirosChecklist(state, value) {
    state.grupoRelatoriosFinanceirosChecklist = value;
  },

  setGrupoVendaClientesCheckAll(state, value) {
    state.grupoVendaClientesCheckAll = value;
  },
  setGrupoVendaClientesChecklist(state, value) {
    state.grupoVendaClientesChecklist = value;
  },

  setGrupoVendaImoveisCheckAll(state, value) {
    state.grupoVendaImoveisCheckAll = value;
  },
  setGrupoVendaImoveisChecklist(state, value) {
    state.grupoVendaImoveisChecklist = value;
  },

  setGrupoVendaContratosCheckAll(state, value) {
    state.grupoVendaContratosCheckAll = value;
  },
  setGrupoVendaContratosChecklist(state, value) {
    state.grupoVendaContratosChecklist = value;
  },

  setGrupoVendaRelatoriosCheckAll(state, value) {
    state.grupoVendaRelatoriosCheckAll = value;
  },
  setGrupoVendaRelatoriosChecklist(state, value) {
    state.grupoVendaRelatoriosChecklist = value;
  },

  setGrupoFinanceiroContasReceberCheckAll(state, value) {
    state.grupoFinanceiroContasReceberCheckAll = value;
  },
  setGrupoFinanceiroContasReceberChecklist(state, value) {
    state.grupoFinanceiroContasReceberChecklist = value;
  },

  setGrupoFinanceiroLancamentosReceberCheckAll(state, value) {
    state.grupoFinanceiroLancamentosReceberCheckAll = value;
  },
  setGrupoFinanceiroLancamentosReceberChecklist(state, value) {
    state.grupoFinanceiroLancamentosReceberChecklist = value;
  },

  setGrupoFinanceiroContasPagarCheckAll(state, value) {
    state.grupoFinanceiroContasPagarCheckAll = value;
  },
  setGrupoFinanceiroContasPagarChecklist(state, value) {
    state.grupoFinanceiroContasPagarChecklist = value;
  },

  setGrupoFinanceiroLancamentosPagarCheckAll(state, value) {
    state.grupoFinanceiroLancamentosPagarCheckAll = value;
  },
  setGrupoFinanceiroLancamentosPagarChecklist(state, value) {
    state.grupoFinanceiroLancamentosPagarChecklist = value;
  },

  setGrupoFinanceiroCaixaCheckAll(state, value) {
    state.grupoFinanceiroCaixaCheckAll = value;
  },
  setGrupoFinanceiroCaixaChecklist(state, value) {
    state.grupoFinanceiroCaixaChecklist = value;
  },

  setGrupoFinanceiroFornecedoresCheckAll(state, value) {
    state.grupoFinanceiroFornecedoresCheckAll = value;
  },
  setGrupoFinanceiroFornecedoresChecklist(state, value) {
    state.grupoFinanceiroFornecedoresChecklist = value;
  },

  setGrupoFinanceiroPlanosContaCheckAll(state, value) {
    state.grupoFinanceiroPlanosContaCheckAll = value;
  },
  setGrupoFinanceiroPlanosContaChecklist(state, value) {
    state.grupoFinanceiroPlanosContaChecklist = value;
  },

  setGrupoFinanceiroGruposContaCheckAll(state, value) {
    state.grupoFinanceiroGruposContaCheckAll = value;
  },
  setGrupoFinanceiroGruposContaChecklist(state, value) {
    state.grupoFinanceiroGruposContaChecklist = value;
  },

  setGrupoFinanceiroRelatoriosCheckAll(state, value) {
    state.grupoFinanceiroRelatoriosCheckAll = value;
  },
  setGrupoFinanceiroRelatoriosChecklist(state, value) {
    state.grupoFinanceiroRelatoriosChecklist = value;
  },

  setGrupoConfiguracoesPretendentesCheckAll(state, value) {
    state.grupoConfiguracoesPretendentesCheckAll = value;
  },
  setGrupoConfiguracoesPretendentesChecklist(state, value) {
    state.grupoConfiguracoesPretendentesChecklist = value;
  },

  setGrupoConfiguracoesCondominiosCheckAll(state, value) {
    state.grupoConfiguracoesCondominiosCheckAll = value;
  },
  setGrupoConfiguracoesCondominiosChecklist(state, value) {
    state.grupoConfiguracoesCondominiosChecklist = value;
  },

  setGrupoConfiguracoesAdministradorasCheckAll(state, value) {
    state.grupoConfiguracoesAdministradorasCheckAll = value;
  },
  setGrupoConfiguracoesAdministradorasChecklist(state, value) {
    state.grupoConfiguracoesAdministradorasChecklist = value;
  },

  setGrupoConfiguracoesUsuariosCheckAll(state, value) {
    state.grupoConfiguracoesUsuariosCheckAll = value;
  },
  setGrupoConfiguracoesUsuariosChecklist(state, value) {
    state.grupoConfiguracoesUsuariosChecklist = value;
  },

  setGrupoConfiguracoesPerfisCheckAll(state, value) {
    state.grupoConfiguracoesPerfisCheckAll = value;
  },
  setGrupoConfiguracoesPerfisChecklist(state, value) {
    state.grupoConfiguracoesPerfisChecklist = value;
  },

  setGrupoConfiguracoesPlacasCheckAll(state, value) {
    state.grupoConfiguracoesPlacasCheckAll = value;
  },
  setGrupoConfiguracoesPlacasChecklist(state, value) {
    state.grupoConfiguracoesPlacasChecklist = value;
  },

  setGrupoConfiguracoesContasCheckAll(state, value) {
    state.grupoConfiguracoesContasCheckAll = value;
  },
  setGrupoConfiguracoesContasChecklist(state, value) {
    state.grupoConfiguracoesContasChecklist = value;
  },

  setGrupoConfiguracoesPortaisCheckAll(state, value) {
    state.grupoConfiguracoesPortaisCheckAll = value;
  },
  setGrupoConfiguracoesPortaisChecklist(state, value) {
    state.grupoConfiguracoesPortaisChecklist = value;
  },

  setGrupoConfiguracoesLogsCheckAll(state, value) {
    state.grupoConfiguracoesLogsCheckAll = value;
  },
  setGrupoConfiguracoesLogsChecklist(state, value) {
    state.grupoConfiguracoesLogsChecklist = value;
  },

  setGrupoConfiguracoesVisitasCheckAll(state, value) {
    state.grupoConfiguracoesVisitasCheckAll = value;
  },
  setGrupoConfiguracoesVisitasChecklist(state, value) {
    state.grupoConfiguracoesVisitasChecklist = value;
  },

  setGrupoConfiguracoesSistemaCheckAll(state, value) {
    state.grupoConfiguracoesSistemaCheckAll = value;
  },
  setGrupoConfiguracoesSistemaChecklist(state, value) {
    state.grupoConfiguracoesSistemaChecklist = value;
  }
}

const actions = {
  listarUsuarios(context, payload) {
    return axios.post(URLS.USUARIOS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaUsuarios', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarUsuarios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  limparUsuarioPesquisa(context) {
    context.commit('limparUsuarioPesquisa');
  },
  limparUsuariosListados(context) {
    context.commit('limparUsuariosListados');
  },
  recuperarUsuario(context, payload) {
    return axios.post(URLS.USUARIOS_RECUPERAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarUsuarioSelecionado', response.data.item);
            context.commit('atualizarPermissoesUsuarioSelecionado', context.state.usuarioSelecionado);
            break;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('recuperarUsuario', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  limparUsuarioSelecionado(context) {
    context.commit('limparUsuarioSelecionado');
    context.commit('limparPermissoesEWidgetsUsuarioSelecionado');
  },
  gravarUsuario(context, payload) {
    return axios.post(URLS.USUARIOS_GRAVAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            if(response.data.item) {
              context.commit('atualizarUsuarioSelecionado', response.data.item);
              context.commit('atualizarPermissoesUsuarioSelecionado', context.state.usuarioSelecionado);
            }
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('gravarUsuario', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  removerUsuario(context, payload) {
    return axios.post(URLS.USUARIOS_REMOVER, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('limparUsuarioSelecionado');
            context.commit('limparPermissoesEWidgetsUsuarioSelecionado');
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('removerUsuario', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  removerConta(context, payload) {
    return axios.post(URLS.USUARIOS_REMOVER_CONTA_BANCARIA, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaContas', response.data.item.contasBancarias);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('removerConta', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  gravarConta(context, payload) {
    return axios.post(URLS.USUARIOS_GRAVAR_CONTA_BANCARIA, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaContas', response.data.item.contasBancarias);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('gravarConta', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  reativarUsuario(context, payload) {
    return axios.post(URLS.USUARIOS_REATIVAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarUsuarioSelecionado', response.data.item);
            context.commit('atualizarPermissoesUsuarioSelecionado', context.state.usuarioSelecionado);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('reativarUsuario', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  ativarUsuario(context, payload) {
    return axios.post(URLS.USUARIOS_ATIVAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarUsuarioSelecionado', response.data.item);
          context.commit('atualizarPermissoesUsuarioSelecionado', context.state.usuarioSelecionado);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
            .then((authResponse) => {
              if(authResponse.status === "SUCESSO") {
                return context.dispatch('ativarUsuario', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  desativarUsuario(context, payload) {
    return axios.post(URLS.USUARIOS_DESATIVAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarUsuarioSelecionado', response.data.item);
          context.commit('atualizarPermissoesUsuarioSelecionado', context.state.usuarioSelecionado);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
            .then((authResponse) => {
              if(authResponse.status === "SUCESSO") {
                return context.dispatch('desativarUsuario', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarPerfis(context, payload) {
    return axios.post(URLS.PERFIS_USUARIO_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarPerfisSelect', response.data.lista);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('listarPerfis', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  gerarFichaUsuario(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
            .then((authResponse) => {
              if(authResponse.status === "SUCESSO") {
                return context.dispatch('gerarFichaUsuario', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  enviarFichaUsuarioPorEmail(context, payload) {
    return axios.post(URLS.RELATORIOS_ENVIAR_POR_EMAIL, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
            .then((authResponse) => {
              if(authResponse.status === "SUCESSO") {
                return context.dispatch('enviarFichaUsuarioPorEmail', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}